<template>

  <v-card
    :disabled="!expand && !completed"
    class="col-12 pa-0 mb-4 bt-step-card"
  >
    <v-card-title>
      {{ title }}
      <v-spacer />
      <v-btn
        v-if="expand"
        :disabled="!valid || !expand"
        small
        color="primary"
        @click="complete"
      >
        Next step
      </v-btn>
    </v-card-title>
    <v-divider v-if="expand" />


    <v-card-text class="pa-0">
      <v-expand-transition>
        <v-form
          v-if="expand"
          v-model="valid"
          class="px-3 pb-7"
        >
          <v-row class="mx-0">
            <v-col
              cols="6"
              md="3"
            >
              <select-project
                v-model="value.project"
                single-line
                :rules="[v => !!v || 'Project is required']"
              ></select-project>
            </v-col>

            <v-col
              cols="6"
              md="3"
            >
              <v-text-field
                label="Title"
                v-model="value.title"
                :rules="[v => !!v || 'Title is required']"
                required
              />
            </v-col>

            <v-col
              cols="6"
              md="3"
            >
              <v-select
                label="Recurring"
                v-model="value.recurring"
                :items="recurring"
                :rules="[v => !!v || 'Recurring is required']"
                hint="The period when bonus can be triggered again"
                persistent-hint
                hide-details1
              />
            </v-col>
          </v-row>
          <v-row class="mx-0">

            <v-col
              cols="12"
              md="2"
            >
              <v-select
                label="Period"
                v-model="value.period"
                :items="periods"
                :rules="[v => !!v || 'Recurring is required']"
                hint="The period when bonus can be triggered again"
                persistent-hint
                return-object
              />
            </v-col>

            <v-col
              v-if="value.period && value.period.additional"
              cols="12"
              md="4"
            >
              <v-select
                label="Period"
                v-model="value.period[value.period.value]"
                :items="value.period.additional"
                :rules="[v => !!v || 'Days is required']"
                multiple
              />
            </v-col>

            <v-col
              v-if="value.period && (value.period.single_date || value.period.date_period)"
              cols="12"
              md="2"
            >
              <date-picker
                v-model="value.period.from"
                label="Start date"
                :check-validation="true"
              />
            </v-col>

            <v-col
              v-if="value.period && value.period.date_period"
              cols="12"
              md="2"
            >
              <date-picker
                v-model="value.period.to"
                label="End date"
                :check-validation="true"
              />
            </v-col>

            <v-col
              cols="12"
              md="6"
            >
              <v-select
                v-model="value.mail_templates"
                :items="mail_templates"
                label="Mail Templates"
                hide-details
                single-line
              />
            </v-col>
          </v-row>
        </v-form>
      </v-expand-transition>
    </v-card-text>
  </v-card>

</template>

<style lang="scss">

  .v-card.v-card--disabled .v-card__title {
    background: #cbcbcb;
  }

  .v-card.v-card--disabled.bt-step-card {
    border-left-color: gray;
  }

  .v-card.bt-step-card {
    border-left: 4px solid #4caf50;
  }

</style>

<script>
  import { map } from 'lodash'
  import SelectProject from '@/components/core/SelectProject/SelectProject.vue'
  import DatePicker from '@/components/core/DatePicker/DatePicker.vue'

  export default {
    components: {
      SelectProject,
      DatePicker
    },
    props: {
      step: {},
      value: {},
      next: {},
      extvalid: {},
      exteditable: {},
      extcompleted: {},
      title: {},
      expand: { default: () => false },
    },

    data: () => ({
      mail_templates: [],
      periods: [
        { text: 'Weekend', value: 'weekend' },
        { text: 'Exact date', value: 'exact_date', single_date: true },
        { text: 'Date period', value: 'date_period', date_period: true },
        {
          text: 'Week days', value: 'weekdays', additional: [
            { text: 'Monday', value: 1 },
            { text: 'Tuesday', value: 2 },
            { text: 'Wednesday', value: 3 },
            { text: 'Thursday', value: 4 },
            { text: 'Friday', value: 5 },
            { text: 'Saturday', value: 6 },
            { text: 'Sunday', value: 7 }
          ]
        },
        { text: 'Month days', value: 'month_days', additional: Array.from({ length: 31 }, (_, i) => i + 1) },
      ],
      recurring: [
        { text: 'Never', value: 'none' },
        { text: '1 Minute', value: 'minute' },
        { text: '1 Hour', value: 'hour' },
        { text: '24 hours', value: '24hours' },
        { text: 'Next day on 12pm UTC', value: 'day' },
        { text: 'Next week', value: 'week' },
        { text: 'Next month', value: 'month' },
      ],
      // valid: false
    }),

    methods: {
      complete () {

        this.completed = true

        this.next(this.step)
      }
    },

    computed: {
      valid: {
        get () {
          return this.extvalid
        },
        set (v) {
          this.$emit('update:extvalid', v)
        }
      },
      editable: {
        get () {
          return this.exteditable
        },
        set (v) {
          this.$emit('update:exteditable', v)
        }
      },
      completed: {
        get () {
          return this.extcompleted
        },
        set (v) {
          this.$emit('update:extcompleted', v)
        }
      },
    },

    watch: {
      expand (v) {
        this.editable = true
      },
    }
  }
</script>

